<template id="app">
<v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
<!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Header-->
    <header-component :headerTitle="headerText" />
    <v-snackbar
      v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- seacrh, action button and filter -->
    <v-card-title style="padding: 25px 25px 15px 15px;" class="action-style pb-0">
      <!-- Search fields -->
      <v-row class="ma-1">
        <v-autocomplete color="primary" v-model="select_field" :items="select_field_items" label="Select Field" variant="outlined" style="max-width: 158px;" class="mr-4 text-left"> </v-autocomplete>
        <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" style="max-width: 270px;" variant="outlined" v-on:keyup.enter="getUsers" :disabled="!select_field"></v-text-field>
          <v-spacer></v-spacer>
        <v-card-actions class="mb-4">
          <v-btn class="mr-2 custum-button text-none" variant="flat" :disabled="selected.length === 0" @click="downloadFile('selected')" color="primary" large style="min-height:55px; min-width:130px; font-weight:600;">Download</v-btn>
          <!-- <v-btn class="mr-2 custum-button text-none" variant="flat" v-if="selected.length === 0" @click="openPopup" color="primary" large style="min-height:55px; min-width:130px; font-weight:600;">Download</v-btn> -->
          <v-btn class="mr-2 custum-button text-none" variant="flat" :disabled="(selected.length === 1)" @click="navigateToFileUpload" color="primary" large style="min-height:55px; min-width:100px; font-weight:600;">Upload</v-btn>
        </v-card-actions>
      </v-row>
    </v-card-title>
     <v-layout column>
      <!-- <v-flex md6 style="overflow: auto"> -->
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          :items-per-page="pageSize"
          fixed-header
          height="100%"
          loading-text="Loading Data... Please wait" 
          class="elevation-1"
          return-object
          >
          <template v-slot:[`item.${headers.key}`]="{ item }" v-for="headers in headers">
              <span v-if="headers.key == 'view_address'">
                <a href="#" @click.prevent="itemDetailPopup(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.view_address }}</a>
              </span> 
              <span v-else-if="headers.key == 'role'">
                <u>{{ getFirstRole(item.role) }}</u>
              </span>
              <span v-else-if="headers.key == 'is_active'">
                <span :style="{ color: item.is_active === true ? 'green' : item.is_active === false ? 'red' : 'black' }">
                  {{ item.is_active === true ? 'Enable' : item.is_active === false ? 'Disable' : '-' }}
                </span>
              </span>
              <span v-else-if="item[headers.key]">
                <GlobalTooltip :text="item[headers.key]" />
                </span>
                <span v-else>-</span>
            </template>
          <template #bottom></template>
        </v-data-table>
      <!-- </v-flex> -->
    </v-layout>
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
</v-card>
</template>
<script>
import HeaderComponent from "../../../../commoncomponents/HeaderComponent.vue";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
export default {
  components: {
    HeaderComponent
  },
  data() {
    return {
      headerText: "BB CRM Surrogate",
      alert : false,
      alert_type : "success",
      alert_message : '',
      search_tag: '',
      loading : false,
      snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: "top",
          text: null,
          timeout: 7500,
          title: null,
          visible: false
        },
      select_field: null,
      select_field_items: ['SR Number', 'Serial Number'],
      selected:[],
      headers : [],
      table_data : [],
      number: 0,
      page: 1,
      totalPages: 1,
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      isSearchFiltering: false,
    }
  },
  async created(){
        this.loadData();
    },
  methods: {
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.scrollToTop();
      this.alertTimeOut();
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 5000);
    },
    loadData(){
        this.search_tag = '';
        this.select_field = null;
        // this.download_message = ''
        this.loading = false;
        this.isFiltering = false;
        this.isSearchFiltering = false;
        this.selected = []
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        this.successPopup = false;
        this.headers = [
          { title: "Upload Date", key: "upload_date"},
          { title: "Complaint Number", key: "crm_parent_ticket_number"},
          { title: "SR Number", key: "crm_ticket_number" },
          { title: "Article ID", key: "article_id" },
          { title: "Serial Number", key: "serial_number" },
          { title: "Return Processing Location", key: "location" },
          { title: "Status", key: "status" },
        ];
        this.getUsers();      
      },
      getUsers() {
        this.loading = true;
        const params = {
            page: this.page,
            per_page: this.pageSize,
        };
         if (this.select_field === 'SR Number') {
                params['filter[crm_ticket_number]'] = this.search_tag;
            } else if (this.select_field === 'Serial Number') {
                params['filter[serial_number]'] = this.search_tag;
            }
        let end_point = '/api/v2/crm_surrogates';

        this.$httpSecured
            .get(end_point, { params })
            .then(response => {
            console.log("API Response:", response);
            if (response && response.data) {
                this.table_data = response.data.crm_surrogates;
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
            } else {
                this.showAlert("error", "No Data Found");
            }
            this.loading = false;
            })
            .catch(error => {
            const errorMsg = error?.response?.data?.error || "Something went wrong";
            this.showAlert("error", errorMsg);
            this.loading = false;
            });
        },
      handlePageSizeChange(size){
        this.pageSize = size;
        this.page = 1
        if(this.isSearchFiltering){
          this.applyFilter('search');
          return;
        }else if(this.isFiltering){
          this.applyFilter('filter');
          return;
        }
        this.getUsers()
      },
      handlePageChange(value) {
        this.page = value;
        if(this.isFiltering){
          this.filterPage = value;
          this.applyFilter('filter');
          return;
        }else if(this.isSearchFiltering){
          this.applyFilter('search');
          return;
        }
        this.getUsers()
      },

      navigateToFileUpload() {
          this.$store.commit("setLotIds", {
          lotIds: this.headerText,
          inventoryId:this.headerText,
          action:'first_tab'
        });      
        this.$router.push({ name: "LotFileuploadComm" });
      },
       downloadFile(value) { 
          this.number++;
          const formData = new FormData();
          const ids = this.selected.map(item => item.id);
          ids.forEach(id => formData.append('surrogate_ids[]', id));        
         let url = '/api/v2/crm_surrogates/download_crm_info'
        this.$httpSecured
          .post(url, formData)
          .then(response => {
              if (response.data) {
               this.downloadDialog = false;
               const url = response.data.url;
              const link = document.createElement('a');
              link.href = url;
              link.download = '';
              document.body.appendChild(link);
              link.click();
              this.snackbar = {
                      color: "success",
                      icon: "mdi-check-circle",
                      mode: "multi-line",
                      position: "top",
                      timeout: 3000,
                      title: "Success",
                      text: "(CSV File) Downloaded Successfully",
                      visible: true
                    };
                  this.selected = [];
                  this.number = 0;
              } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");
                  this.number = 0;
              }
          })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.number = 0;
        });
      },
  }
}
</script>
<style>
.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 300px) !important;
}
</style>